module.exports = __webpack_public_path__ + "img/玛恩.92cc761.png";